export const blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  octalBlue: "#282d32",
  900: "#336fe4",
};
export const yellow = {
  50: "#ffeb3b",
  100: "#fffde7",
  200: "#fff9c4",
  300: "#fff59d",
  400: "#fff176",
  500: "#ffee58",
  600: "#ffeb3b",
  700: "#fdd835",
  800: "#fbc02d",
  900: "#efc72d",
};
export const gray = {
  50: "#e5e5e5",
  100: "#171d22",
  200: "#242b33",
  300: "#303a46",
  400: "#404b58",
  500: "#6b727b",
  600: "#8a919b",
  700: "#c7ccd3",
  800: "#d9dee5",
  900: "#191d20",
};

export const black = {
  blackPearl: "#181E22",
};

export const nickel = '#6e747b';

export const codeBlockTheme = {
  lineNumberColor: "#7B85A4",
  lineNumberBgColor: "#191D20",
  backgroundColor: "#191D20",
  textColor: "#FFF",
  substringColor: "#FF79C6",
  keywordColor: "#FF79C6",
  attributeColor: "#FFF",
  selectorTagColor: "#50FA7B",
  docTagColor: "#7294FF",
  nameColor: "#7294FF",
  builtInColor: "#50FA7B",
  literalColor: "#50FA7B",
  bulletColor: "#50FA7B",
  codeColor: "#FFF",
  additionColor: "#FFF",
  regexpColor: "#FFF",
  symbolColor: "#50FA7B",
  variableColor: "#50FA7B",
  templateVariableColor: '#50FA7B',
  linkColor: "#BD93F9",
  selectorAttributeColor: "#FFF",
  selectorPseudoColor: "#FFF",
  typeColor: "#FFF",
  stringColor: "#EFC72D",
  selectorIdColor: '#7B85A4',
  selectorClassColor: '#7B85A4',
  quoteColor: '#7B85A4',
  templateTagColor: '#7B85A4',
  deletionColor: '#FFF',
  titleColor: '#7B85A4',
  sectionColor: '#7B85A4',
  commentColor: "#7294FF",
  metaKeywordColor: '#50FA7B',
  metaColor: '#FFF',
  functionColor: '#FFF',
  numberColor: "#BD93F9",
};
